import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantConfigService } from 'app/core/tenant';

/**
 * Route guard that blocks access to public signup routes when
 * the tenant's onboarding configuration has `inviteOnly: true`.
 *
 * When blocked, redirects to the filmmaker sign-in page.
 *
 * Usage in routes:
 *   { path: 'sign-up', canActivate: [InviteOnlyGuard], ... }
 */
export const InviteOnlyGuard: CanActivateFn = (): boolean => {
    const tenantConfig = inject(TenantConfigService);
    const router = inject(Router);

    const config = tenantConfig.safeGetConfig();

    // If config not loaded yet or inviteOnly is true, block signup
    if (config?.onboarding.inviteOnly) {
        router.navigateByUrl('/sign-in');
        return false;
    }

    return true;
};
